import React, { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CursorFX from "@/components/CursorFX";
import ScrollProgress from "@/components/ScrollProgress";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Contatti from "@/pages/Contatti";
import Preventivo from "@/pages/Preventivo";
import Legal from "@/pages/Legal";
import BrandAssets from "@/pages/BrandAssets";
import HomeEn from "@/pages/en/HomeEn";
import ChiSiamoEn from "@/pages/en/ChiSiamoEn";
import ServiziEn from "@/pages/en/ServiziEn";
import ContattiEn from "@/pages/en/ContattiEn";
import QuoteEn from "@/pages/en/QuoteEn";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
          <div>
            <p className="font-serif text-3xl text-bone">ZAICHAUFFER</p>
            <p className="mt-4 text-sm text-mute">
              Si è verificato un errore. Ricarica la pagina.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageFade({ children }) {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-ink text-bone antialiased">
      <div className="grain" aria-hidden="true" />
      <ErrorBoundary>
        <ScrollProgress />
        <CursorFX />
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <PageFade>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/chi-siamo" element={<ChiSiamo />} />
                <Route path="/servizi" element={<Servizi />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/richiedi-preventivo" element={<Preventivo />} />
                <Route path="/area-stampa" element={<BrandAssets />} />
                <Route path="/privacy-policy" element={<Legal page="privacy" />} />
                <Route path="/cookie-policy" element={<Legal page="cookie" />} />
                <Route path="/en" element={<HomeEn />} />
                <Route path="/en/about-us" element={<ChiSiamoEn />} />
                <Route path="/en/services" element={<ServiziEn />} />
                <Route path="/en/contacts" element={<ContattiEn />} />
                <Route path="/en/get-a-quote" element={<QuoteEn />} />
                <Route path="/en/privacy-policy" element={<Legal page="privacy" lang="en" />} />
                <Route path="/en/cookie-policy" element={<Legal page="cookie" lang="en" />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </PageFade>
          </main>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
